import { createContext, useContext, useState } from 'react'

const DeviceInfoContext = createContext()
const DeviceInfoConsumer = DeviceInfoContext.Consumer

const DeviceInfoProvider = ({ children, deviceInfo: initialDeviceInfo = {} }) => {
  const [deviceInfo] = useState(initialDeviceInfo)

  return <DeviceInfoContext.Provider value={deviceInfo}>{children}</DeviceInfoContext.Provider>
}

const useDeviceInfo = () => useContext(DeviceInfoContext)

export default DeviceInfoContext

export { DeviceInfoProvider, DeviceInfoConsumer, useDeviceInfo }
